class Video {
  constructor(options = {}) {
    this.config = {
      moduleList: document.querySelectorAll('[data-module="Video"]'),
      ...options
    };
  }

  static toggleSound(status, player) {
    player.setVolume(status ? 1 : 0);
  }

  static isVimeo(iframe) {
    return iframe.src.includes('vimeo.com');
  }

  init() {
    const { moduleList } = this.config;

    moduleList.forEach(module => {
      const iframe = module.querySelector('iframe');
      let player;

      if (!iframe.src.includes('autoplay=1') || iframe.src.includes('youtube.com')) {
        return;
      }

      if (Video.isVimeo(iframe)) {
        const vimeo = new Vimeo.Player(iframe); // eslint-disable-line no-undef

        player = {
          instance: vimeo,
          setVolume: amount => vimeo.setVolume(amount)
        };
      }

      // controls
      const controls = module.querySelector('[data-child-module="VideoControls"]');
      const mute = controls.querySelector('.js-soundtoggle-mute');
      const unmute = controls.querySelector('.js-soundtoggle-unmute');

      // display sound toggle if video has autoplay
      unmute.classList.remove('hidden');

      mute.addEventListener('click', () => {
        mute.classList.add('hidden');
        unmute.classList.remove('hidden');
        Video.toggleSound(false, player);
      });

      unmute.addEventListener('click', () => {
        unmute.classList.add('hidden');
        mute.classList.remove('hidden');
        Video.toggleSound(true, player);
      });
    });
  }
}

export default Video;
